module.exports = __webpack_public_path__ + "img/info.3c745746.png";